/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Button } from '@atoms';
import { Form } from '@organisms';

const ButtonField = ({ buttonText, disabled, ...props }) => {
  return (
    <Form.Item {...props}>
      <Button disabled={disabled}>{buttonText}</Button>
    </Form.Item>
  );
};

export default ButtonField;
